if(!customElements.get('newsletter-invalid')){
    class NewsletterInvalidMessage extends HTMLElement {
        constructor(){
            super();

            this.email = this.dataset.email.trim();
            this.emailExists = this.querySelector('.email-exists');
            this.invalidEmail = this.querySelector('.invalid-email');

            if(this.email == '') return;

            const validateEmail = this.validateEmail(this.email);
            this.emailExists.setAttribute('aria-hidden', validateEmail? 'false':'true');
            this.invalidEmail.setAttribute('aria-hidden', validateEmail? 'true': 'false');
        }

        validateEmail(email){
            var emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            return emailRegex.test(email);
        }
    }

    customElements.define('newsletter-invalid', NewsletterInvalidMessage);
}